import styles from './AssessmentAnalysisCard.module.scss';
import { Text } from '../typography';
import { Icon } from '@mui/material';
import { useRef, useState } from 'react';
import { loader } from 'graphql.macro';
import { useSubscription } from '@apollo/client';
import Button from '../Button';
import { useAIMutations } from '../../hooks/AI/AI_hooks';
import Accordian from '../Accordian';
import { customColors } from '../../utilities';
import { modalLoadingMessage } from './riskAnalysis';
import { useTranslation } from 'react-i18next';

const secondsightSubscription = loader(
  'src/hooks/AI/secondSightSubscription.graphql',
);

export default function AssessmentAnalysisCard({
  message,
  analysis,
  disclaimer,
  inspectionId,
  expand,
}) {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const { secondSightAnalysis } = useAIMutations();
  const analysisStartedRef = useRef(false);
  const [newAnalysis, setNewAnalysis] = useState([]);

  useSubscription(secondsightSubscription, {
    variables: { inspectionId },
    skip: !inspectionId || !!analysis,
    onSubscriptionData: ({
      subscriptionData: {
        data: { secondsightProcessed: { riskAnalysis = '' } } = {},
      } = {},
    }) => {
      setIsAnalyzing(false);
      analysisStartedRef.current = false;
      setNewAnalysis(riskAnalysis);
    },
  });

  const handleStart = async () => {
    setIsAnalyzing(true);
    analysisStartedRef.current = true;
    await secondSightAnalysis({ id: inspectionId });
  };

  const displayAnalysis = analysis || newAnalysis || [];
  const { t } = useTranslation();

  return (
    <Accordian
      backgroundColor={customColors.BLUE}
      textColor="white"
      iconProps={{ color: 'white' }}
      size="md"
      messageVariant="white"
      title="SecondSight"
      icon="analytics"
      accordianSize={true}
      expand={expand}
    >
      {isAnalyzing ? (
        <div>
          <Text size="md" textAlign="center" noMargin>
            {t(modalLoadingMessage.title)}
          </Text>
        </div>
      ) : (
        <>
          <div className={styles.message}>
            <Text weight="semiBold" color="secondary" textAlign="center">
              {message}
            </Text>
          </div>
          {!analysis?.length ? (
            <div className={styles.center}>
              <Button
                align={'center'}
                value="Start"
                icon="auto_fix_high"
                onClick={handleStart}
              />
            </div>
          ) : (
            <div className={styles.analysis}>
              {displayAnalysis?.map((a, index) => (
                <div className={styles.analysisList} key={a + index}>
                  <Icon sx={{ color: 'red' }}>flag_circle</Icon>
                  <Text weight="bold" noMargin>
                    {a}
                  </Text>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Accordian>
  );
}
